import {
  DisplayConceptRef,
  DisplayUserFollow,
  DisplayUser,
  updateFollows,
  UpdateFollowAction,
} from '@/lib/api';

export const followsMap = (
  follows: DisplayUserFollow[] | null
): Map<string, DisplayConceptRef[]> => {
  const followsMap = new Map<string, DisplayConceptRef[]>();
  if (follows != null) {
    follows.forEach((follow) => {
      followsMap.set(follow.username, follow.topics);
    });
  }
  return followsMap;
};

export const followTopic = async (topic: DisplayConceptRef): Promise<DisplayUser> => {
  const action: UpdateFollowAction = 'follow';
  return updateFollows({
    action,
    topics: [topic.cref],
  });
};

export const unfollowTopic = async (topic: DisplayConceptRef): Promise<DisplayUser> => {
  const action: UpdateFollowAction = 'unfollow';
  return updateFollows({
    action,
    topics: [topic.cref],
  });
};
